import { WelcomeView } from "../coms/welcome-view";
import SessionProvider from "../coms/SessionProvider";
import { RoomAudioRenderer, StartAudio } from '@livekit/components-react';
import ViewController from "../coms/view-control";

export default function VoiceChat() {
  return (
    <SessionProvider agentName={"test-voice"}>
       <div><ViewController/></div>
       <StartAudio label="Start Audio" />
       <RoomAudioRenderer />
    </SessionProvider>
  );
}